<mat-card appearance="outlined">
  <app-vinavon-button>
    <button mat-raised-button class="vinavonButton" (click)="addArticle()"
    [ngClass]="currTerminExists && !currTerminFinished ? 'btnenabled' : 'btndisabled'">
      <mat-icon>note_add</mat-icon>
      {{ " Artikel erfassen" }}
    </button>

    <button mat-raised-button class="vinavonButton" (click)="showArticles()"
    [ngClass]="currTerminExists && !currTerminFinished ? 'btnenabled' : 'btndisabled'">
      <mat-icon>article_shortcut</mat-icon>
      {{ "Artikelstamm" }}
    </button>

    <button mat-raised-button class="vinavonButton" (click)="editArticle()"
    [ngClass]="isProductSelected && !currTerminFinished ? 'btnenabled' : 'btndisabled'">
      <mat-icon>edit_document</mat-icon>
      {{ "Artikel bearbeiten" }}
    </button>
  
    <button mat-raised-button class="vinavonButton"(click)="delArticle()"
    [ngClass]="isProductSelected && !currTerminFinished ? 'btnenabled' : 'btndisabled'">
      <mat-icon>delete_forever</mat-icon>
      {{ "Artikel löschen" }}
    </button>
   
  </app-vinavon-button>
  <ejs-grid
    #gridPositionen [dataSource]="positionsZeilen | async"
    (rowSelected)="rowSelected($event)"
    (rowDeselected)="rowDeselected($event)"
    >
    <e-columns>
      <e-column field="servicePosID" headerText="Datum" width="0"></e-column>
      <e-column
        field="datum"
        headerText="Datum"
        textAlign="Right"
        width="110"
      ></e-column>
      <e-column
        field="mitarbeiter"
        headerText="Mitarbeiter"
        textAlign="Left"
      ></e-column>
      <e-column
        field="artikelnummer"
        headerText="Artikel Nr."
        textAlign="Left"
      ></e-column>
      <e-column
        field="bezeichnung"
        headerText="Bezeichnung"
        textAlign="Left"
      ></e-column>
      <e-column
        field="anzahl"
        headerText="Anzahl"
        textAlign="Left"
        width="80"
      ></e-column>
      <e-column
        field="preisProEinheit"
        headerText="Preis/Einheit"
        textAlign="Right"
      ></e-column>
      <e-column
        field="laengeBreiteDicke"
        headerText="Länge/Breite/Dicke"
        textAlign="Left"
      ></e-column>
      <e-column field="menge" headerText="Menge" textAlign="Left"></e-column>
      <e-column
        field="kulanzSpesen"
        headerText="Kulanz/Spesen"
        textAlign="Center"
      >
        <ng-template #template let-data>
          <img
            style="width: 16px; height: 16px"
            src="/assets/images/{{ imgSrc(data.kulanz) }}"
          />
          /
          <img
            style="width: 16px; height: 16px"
            src="/assets/images/{{ imgSrc(data.spesen) }}"
          />
        </ng-template>
      </e-column>
      <e-column
        field="preisTotal"
        headerText="Preis Total"
        textAlign="Right"
      ></e-column>
    </e-columns>
    <e-aggregates>
      <e-aggregate>
        <e-columns>
          <e-column
            columnName="preisTotal"
            type="Custom"
            [customAggregate]="customAggregateFn"
          >
            <ng-template #footerTemplate let-data>
              {{ "MAIN_APP_SERVICE_APP.summe" | translate }}:
              {{ data.Custom }}</ng-template
            >
          </e-column>
        </e-columns>
      </e-aggregate>
    </e-aggregates>
  </ejs-grid>
</mat-card>
